import React from 'react'
import PropTypes from 'prop-types'
import { Card, Spin, Tag, Descriptions } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import './Component.css'

export default class _SettingsPanel_ extends React.PureComponent {

  static propTypes = {
    settings: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
  }

  renderEnabledTag = (value) => {
    var isEnabled = value === 'Enabled' || value === '1' || value === 1 || value === true || value === 'true'
    if (isEnabled) {
      return <Tag color="green" icon={<CheckCircleOutlined />}>Enabled</Tag>
    }
    return <Tag color="red" icon={<CloseCircleOutlined />}>Disabled</Tag>
  }

  formatValue = (key, value, definition) => {
    if (!definition) {
      return value || 'Not set'
    }

    // Checkbox / boolean fields
    if (definition.field_type_id === 5) {
      return this.renderEnabledTag(value)
    }

    // Select fields with processor_json options
    if (definition.processor_json) {
      try {
        var options = JSON.parse(definition.processor_json)
        if (Array.isArray(options)) {
          var option = options.find(function(opt) { return opt.value === value })
          if (option && option.label) {
            // Render as colored tag if the resolved label is Enabled/Disabled
            if (option.label === 'Enabled' || option.label === 'Disabled') {
              return this.renderEnabledTag(option.label)
            }
            return option.label
          }
        }
      } catch (e) {
        // fall through
      }
    }

    // Catch any raw Enabled/Disabled values that weren't matched above
    if (value === 'Enabled' || value === 'Disabled') {
      return this.renderEnabledTag(value)
    }

    // Number fields with special formatting
    if (definition.field_type_id === 2) {
      switch (key) {
        case 'rams_reminder_days':
          return value && value !== '0' ? 'Every ' + value + ' day' + (value !== '1' ? 's' : '') : 'No reminders'
        case 'rams_expiry_days':
          return value && value !== '0' ? value + ' day' + (value !== '1' ? 's' : '') : 'Never expires'
        default:
          return value || 'Not set'
      }
    }

    return value || 'Not set'
  }

  render () {

    var { settings, loading } = this.props

    if (loading) {
      return (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <Spin />
        </div>
      )
    }

    var values = (settings && settings.values) || {}
    var definitions = (settings && settings.definitions) || {}

    if (Object.keys(values).length === 0) {
      return null
    }

    var settingsConfig = [
      { key: 'rams_enabled', label: 'RAMS System' },
      { key: 'rams_send_schedule', label: 'Send Schedule' },
      { key: 'rams_send_email', label: 'Email Notifications' },
      { key: 'rams_send_sms', label: 'SMS Notifications' },
      { key: 'rams_reminder_days', label: 'Reminder Days' },
      { key: 'rams_require_signature', label: 'Require Signature' },
      { key: 'rams_generate_pdf', label: 'Generate PDF Reports' },
      { key: 'rams_expiry_days', label: 'RAMS Expiry' },
      { key: 'rams_auto_supersede', label: 'Auto-Supersede' },
    ]

    return (
      <div className="rams-settings-wrapper">
        <Card title="RAMS Settings" size="small">
          <Descriptions column={{ xxl: 3, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }} size="small" bordered>
            {settingsConfig.map(function(item) {
              return (
                <Descriptions.Item key={item.key} label={item.label}>
                  {this.formatValue(item.key, values[item.key], definitions[item.key])}
                </Descriptions.Item>
              )
            }.bind(this))}
          </Descriptions>
        </Card>
      </div>
    )
  }
}
